// import { IReduxState } from '../app/types';
import { setActiveModalId } from '../base/modal';
import { PARTICIPANT_LEFT } from '../base/participants/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { BREAKOUT_ROOM_MODAL_ID, CLOSE_BREAKOUT_ROOM_MODAL, OPEN_BREAKOUT_ROOM_MODAL } from '../breakout-rooms/actionTypes';
import { CLOSE_PARTICIPANTS_PANE_MODAL, OPEN_PARTICIPANTS_PANE_MODAL, PARTICIPANTS_PANE_MODAL_ID } from '../participants-pane/actionTypes';
import { CLOSE_LANGUAGE_SELECTOR_MODAL, LANGUAGE_SELECTOR_MODAL_ID, OPEN_LANGUAGE_SELECTOR_MODAL } from '../subtitles/actionTypes';

import {
    ADD_GIF_FOR_PARTICIPANT,
    CLOSE_GIF_MODAL,
    GIF_MODAL_ID,
    HIDE_GIF_FOR_PARTICIPANT,
    OPEN_GIF_MODAL,
    SHOW_GIF_FOR_PARTICIPANT
} from './actionTypes';
import { removeGif } from './actions';
import { GIF_DEFAULT_TIMEOUT } from './constants';
import { getGifForParticipant } from './function.any';

/**
 * Middleware which intercepts Gifs actions to handle changes to the
 * visibility timeout of the Gifs.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    const { dispatch, getState } = store;
    const state = getState();

    switch (action.type) {
    case ADD_GIF_FOR_PARTICIPANT: {
        const id = action.participantId;
        const { giphy } = state['features/base/config'];

        _clearGifTimeout(state, id);
        const timeout = typeof action.timeout === 'number'
            ? action.timeout
            : giphy?.tileTime || GIF_DEFAULT_TIMEOUT;
        const timeoutID = setTimeout(
                () => dispatch(removeGif(id)),
                timeout
        );

        action.timeoutID = timeoutID;
        break;
    }
    case PARTICIPANT_LEFT: {
        const id = action.participant?.id;

        if (id) {
            _clearGifTimeout(state, id);
            dispatch(removeGif(id));
        }
        break;
    }
    case SHOW_GIF_FOR_PARTICIPANT: {
        const id = action.participantId;

        _clearGifTimeout(state, id);
        break;
    }
    case OPEN_PARTICIPANTS_PANE_MODAL: {
        if (dispatch) {
            dispatch(setActiveModalId(PARTICIPANTS_PANE_MODAL_ID));
        }
        break;
    }
    case CLOSE_PARTICIPANTS_PANE_MODAL: {
        if (dispatch) {
            dispatch(setActiveModalId());
        }
        break;
    }
    case OPEN_BREAKOUT_ROOM_MODAL: {
        if (dispatch) {
            dispatch(setActiveModalId(BREAKOUT_ROOM_MODAL_ID));
        }
        break;
    }
    case CLOSE_BREAKOUT_ROOM_MODAL: {
        if (dispatch) {
            dispatch(setActiveModalId());
        }
        break;
    }
    case OPEN_LANGUAGE_SELECTOR_MODAL: {
        if (dispatch) {
            dispatch(setActiveModalId(LANGUAGE_SELECTOR_MODAL_ID));
        }
        break;
    }
    case CLOSE_LANGUAGE_SELECTOR_MODAL: {
        if (dispatch) {
            dispatch(setActiveModalId());
        }
        break;
    }
    case OPEN_GIF_MODAL: {
        if (dispatch) {
            dispatch(setActiveModalId(GIF_MODAL_ID));
        }
        break;
    }

    case CLOSE_GIF_MODAL: {
        if (dispatch) {
            dispatch(setActiveModalId());
        }
        break;
    }
    case HIDE_GIF_FOR_PARTICIPANT: {
        const { giphy } = state['features/base/config'];
        const id = action.participantId;
        const timeoutID = setTimeout(
                () => dispatch(removeGif(id)),
                giphy?.tileTime || GIF_DEFAULT_TIMEOUT
        );

        action.timeoutID = timeoutID;
        break;
    }
    }

    return next(action);
});

/**
 * Clears GIF timeout.
 *
 * @param {Object} state - Redux state.
 * @param {string} id - Id of the participant for whom to clear the timeout.
 * @returns {void}
 */
function _clearGifTimeout(state: Object, id: string) {
    const gif = getGifForParticipant(state, id);

    clearTimeout(gif?.timeoutID ?? -1);
}
